import { combineReducers } from 'redux';

import {
  LOGIN_RESPONSE,
  HANDLE_LOADER,
  TRIAGE_BASIC_INFO,
  FORGOT_PASSWORD,
  GET_STATE_ALL,
  GET_CITY,
  GET_TIMEZONE_ALL,
  TRIAGE_TYPE,
  RING_GROUP_LIST,
  IVR_LIST,
  HOSPITAL_LIST,
  AUDIO_LIST,
  DOCUMENT_SETTING,
  SEARCH_NUMBER_RESPONSE,
  GET_HOSPITALS_ALL,
  UPDATE_STATUS_HOSPITAL_SUCCESS,
  GET_SEARCHED_HOSPITALS_ALL,
  SET_CURRENT_HOSPITAL,
  SET_WELCOME_MESSAGE_DATA,
  SET_KEY_ACTION_DATA,
  CREATE_CHAIN_ADD,
  GET_CHAINS_ALL,
  CLEAR_HOSPITAL_ONBOARD,
  GET_SEARCHED_CHAINS_ALL,
  UPLOAD_RECORDING,
  GET_RECORDING_LISTS,
  SET_HOSPITAL_RING_REL,
  DELETE_RECORDING,
  SET_RING_GROUP_LIST,
  CREATED_RING_GROUP,
  CREATED_IVR,
  SET_IVR_LIST,
  GET_NURSES_ALL,
  GET_SEARCHED_NURSES_ALL,
  CREATE_NURSE_ADD,
  UPDATE_STATUS_NURSE_SUCCESS,
  SET_HOSPITAL_IVR_REL,
  SET_NURSE_BY_ID,
  SET_ROLES_LIST,
  SET_ROLES_WITH_PERM_LIST,
  GET_NURSE_ROLES_WITH_PERM,
  GET_QUESTION,
  GET_CONTACT,
  GET_EMAIL,
  DELETE_HOSPITAL,
  GET_MARKET_OUTREACH,
  GET_GV_FEE,
  SET_START_END_DATE,
  SET_DASHBOARD_ALL_DATA_COUNT,
  SET_CUSTOMER_FEEDBACK,
  SET_CALLS_COUNT,
  SET_PREFERENCES_ALL_VALUES,
  SET_TOP_ISSUES,
  SET_CASES_COUNT_MONTH,
  SET_CASES_COUNT_WEEK,
  SET_CASES_COUNT_YEAR,
  SET_CLIENTS_COUNT_MONTH,
  RESET_DASHBOARD_DATA,
  GET_ALL_HOSPITAL_LIST,
  HOSPITAL_LIST_CHAIN,
  CLEAR_ALL_HOSPITALS,
  SET_CLINIC_HOURS_EVENTS,
  SET_CLINIC_HOURS_TIMEZONE,
  SET_SETUP_SCHEDULE_MODAL_VISIBILITY,
  SET_INITIAL_DATE_CLINIC_HOURS,
  SET_SETUP_SCHEDULE_EDIT_STATE,
  SET_SETUP_SCHEDULE_DATE_CLICKED_STATE,
  RESET_SETUP_SCHEDULE_DATA,
  UPDATE_SETUP_SCHEDULE_DATA,
  CLEAR_STATE_REDUX,
  SET_PAYMENT_CALCULATION,
  SET_PAYMENT_LISTING,
  SET_HOSPITAL_DVM_LISTING,
  SET_HOSPITAL_CONSULT_LISTING,
  SET_START_END_DATE_PAYMENT,
  GET_ALL_HOSPITAL_LIST_PAYMENT,
  GET_GREETINGS,
  CLEAR_GREETINGS,
  SET_START_END_DATE_COMM_LOG,
  GET_ALL_HOSPITAL_LIST_COMM,
  SET_COMM_LOGS,
  SET_TELE_MED_TOP_ISSUES,
  SET_AVG_CONSULATION_PRICE,
  SET_USER_CREATED_PROFILECOUNT,
  SET_DVM_USED_APP_COUNT,
  SET_APPOINTMENT_DVM_MONTH,
  SET_CALL_NOTIFICATIONS_MINUTES,
  SET_CALL_NOTIFICATIONS_LIST,
  GET_REFERRAL_HOSPITAL_INFORMATION,
  POST_REFERRAL_HOSPITAL_INFORMATION,
  UPDATE_REFERRAL_HOSPITAL_INFORMATION,
  SET_ON_CALL_PROTOCOL,
  SET_SPECIES_MASTER_LIST,
  SET_BREEDS_MASTER_LIST,
  SET_GENDERS_MASTER_LIST,
  SET_STATES_MASTER_LIST,
  SET_TIMEZONES_MASTER_LIST,
  SET_CHIEF_COMPLAINTS_MASTER_LIST,
  SET_CURBSIDE_ANALYTICS,
  GET_CALL_MATRIX_SUCCESS,
  SET_CHAINED_HOSPITALS_COMM_LOG,
} from '../types/Types';
import newDashboardReducer from './NewDashboardReducer';

const initialState = {
  loader: false,
  loginResponse: {},
  forgotPassword: {},
  allAudioList: { count: 0, recordings: [] },
  allRingGroupList: { count: 0, ringGroups: [] },
  allIvrList: { count: 0, ivrs: [] },
  allHospitalList: { count: 0, hospitals: [] },
  allHospitalListChain: [],
  allStateList: [],
  citiesArray: [],
  allTimeZoneList: [],
};

const triageSetupState = {
  triageBasicInfo: {},
  triageType: {},
  ringGroupRel: {},
  documentSetting: {},
  searchNumberResponse: [],
  ivrRel: {},
};

const hospitalInitialState = {
  hospitalList: {},
  limit: 20,
  offset: 0,
  currentHospital: {},
  isSearchRing: false,
  searchedRingList: [],
  searchedIVRList: [],
  isSearchIVR: false,
};

const initialChainState = {
  chainList: { count: 0, Chain: [] },
  limit: 20,
  offset: 0,
};

const initialRecordingState = {
  recordings: { recordings: [], count: 0 },
  limit: 20,
  offset: 0,
};

const initialRingGroupState = {
  ringGroupList: { ringGroups: [], count: 0 },
  limit: 20,
  offset: 0,
};

const initialRolesState = {
  roleList: [],
  limit: 20,
  offset: 0,
};

const initialPermissionState = {
  rolePermList: [],
  limit: 20,
  offset: 0,
};

const initialIVRCreateState = {
  ivrList: { count: 0, ivrs: [] },
  limit: 20,
  offset: 0,
  welcomePageData: {},
  chooseActionPageData: [],
};

const initialNurseState = {
  nurseList: { count: 0, nurses: [] },
  limit: 20,
  offset: 0,
  nurse: {},
  roles: [],
};

// Help and support initial states
const initialHelpAndSupportState = {
  questions: [],
  contacts: [],
  emails: [],
  marketOutreach: [],
};

const dashboardState = {
  allDataCount: null,
  casesByWeek: [],
  casesByMonth: [],
  casesByYear: [],
  clientsByMonth: [],
  callsCountEveryHour: null,
  callsCountEveryDay: null,
  topFiveIssues: null,
  // customerFeedback: null,
  nurseFeedback: null,
  dvmFeedback: null,
  allPreferenceValues: null,
  startDate: null,
  endDate: null,
  allDashboardHospitalList: [],
  paymentCalculationValue: null,
  teleMedTopFiveIssues: null,
  avgConsultationPrice: 0,
  dvmUsedAppCount: 0,
  userCreateProfileCount: 0,
  appointmentDVMMonth: null,
  curbsideAnalytics: null,
};

const clinicHoursState = {
  events: [],
  timezone: '',
  setUpScheduleState: false,
  setUpScheduleDateClicked: false,
  setUpScheduleEdit: false,
  initialDate: null,
  setUpScheduleData: {
    title: '',
    startDate: null,
    endDate: null,
    inTime: [null],
    outTime: [null],
    repeat: 'daily',
    repeatValue: '1',
    monthSelect: null,
    dayState: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
    },
  },
};

const paymentInitialState = {
  paymentList: [],
  limit: 20,
  offset: 0,
  count: 0,
  dvmList: [],
  consultList: [],
  cardValues: {},
  startDate: null,
  endDate: null,
  allPaymentHospitalList: [],
};

const initialGreetingsState = {
  greetings: [],
};

const commLogInitialState = {
  limit: 20,
  offset: 0,
  count: 0,
  dvmList: [],
  totalCardDetails: {},
  startDate: null,
  endDate: null,
  allCommHospitalList: [],
  communicationLogs: [],
  chainedHospitals: [],
  callMatrics: {},
  showCallMatricsModal: false,
};

const initialCallNotificationsState = {
  callNotifications: [],
  minutes: 0,
};

const onCallProtocolState = {
  referralData: [],
  onCallProtocol: {},
};

function loginReducer(state = initialState, action) {
  const newState = { ...state };

  if (action.type === LOGIN_RESPONSE) {
    newState.loginResponse = action.payload;
  }

  if (action.type === FORGOT_PASSWORD) {
    newState.forgotPassword = action.payload;
  }
  return newState;
}

const initialSpeciesMasterState = {
  speciesList: { rows: [], count: 0 },
  limit: 20,
  offset: 0,
};

const initialBreedsMasterState = {
  breedsList: { rows: [], count: 0 },
  limit: 20,
  offset: 0,
};

const initialGendersMasterState = {
  gendersList: { rows: [], count: 0 },
  limit: 20,
  offset: 0,
};

const initialStatesMasterState = {
  statesList: { rows: [], count: 0 },
  limit: 20,
  offset: 0,
};

const initialTimezonesMasterState = {
  timezonesList: { rows: [], count: 0 },
  limit: 20,
  offset: 0,
};

const initialChiefComplaintsMasterState = {
  chiefComplaintsList: { rows: [], count: 0 },
  limit: 20,
  offset: 0,
};

function triageSetupReducer(state = triageSetupState, action) {
  const newState = { ...state };

  if (action.type === TRIAGE_BASIC_INFO) {
    newState.triageBasicInfo = action.payload;
  }

  if (action.type === TRIAGE_TYPE) {
    newState.triageType = action.payload;
  }

  if (action.type === SET_HOSPITAL_RING_REL) {
    newState.ringGroupRel = action.payload;
  }

  if (action.type === SEARCH_NUMBER_RESPONSE) {
    return { ...state, searchNumberResponse: action.payload };
  }

  if (action.type === DOCUMENT_SETTING) {
    newState.documentSetting = action.payload;
  }

  if (action.type === SET_HOSPITAL_IVR_REL) {
    newState.ivrRel = action.payload;
  }

  if (action.type === CLEAR_HOSPITAL_ONBOARD) {
    newState.triageBasicInfo = {};
    newState.currentRingGroup = {};
    newState.triageType = {};
    newState.ringGroupRel = {};
    newState.documentSetting = {};
    newState.searchNumberResponse = [];
    newState.ivrRel = {};
  }

  return { ...newState };
}
function rootReducer(state = initialState, action) {
  if (action.type === HANDLE_LOADER) {
    return { ...state, loader: action.payload };
  }

  if (action.type === AUDIO_LIST) {
    return { ...state, allAudioList: action.payload };
  }

  if (action.type === RING_GROUP_LIST) {
    return { ...state, allRingGroupList: action.payload };
  }

  if (action.type === IVR_LIST) {
    return { ...state, allIvrList: action.payload };
  }

  if (action.type === HOSPITAL_LIST) {
    return { ...state, allHospitalList: action.payload };
  }

  if (action.type === HOSPITAL_LIST_CHAIN) {
    return { ...state, allHospitalListChain: action.payload };
  }

  if (action.type === GET_STATE_ALL) {
    return { ...state, allStateList: action.payload };
  }
  if (action.type === GET_CITY) {
    return { ...state, citiesArray: action.payload };
  }
  if (action.type === GET_TIMEZONE_ALL) {
    return { ...state, allTimeZoneList: action.payload };
  }

  return state;
}

function hospitalDetailReducer(state = hospitalInitialState, action) {
  if (action.type === GET_HOSPITALS_ALL) {
    return {
      ...state,
      hospitalList: action.hospitalList,
      offset: action.offset,
    };
  }

  if (action.type === UPDATE_STATUS_HOSPITAL_SUCCESS) {
    const { hospitals } = state.hospitalList;
    const id = hospitals.findIndex(
      (hospital) => hospital.id === action.hospital.id
    );
    hospitals[id].status = action.hospital.status;

    return {
      ...state,
      hospitalList: { ...state.hospitalList, hospitals },
    };
  }

  if (action.type === GET_SEARCHED_HOSPITALS_ALL) {
    return {
      ...state,
      hospitalList: action.hospitalList,
      offset: action.offset,
    };
  }

  if (action.type === DELETE_HOSPITAL) {
    const { hospitals } = state.hospitalList;
    const { count } = state.hospitalList;
    hospitals.splice(
      hospitals.findIndex((hosp) => hosp.id === action.hospitalId),
      1
    );

    return { ...state, hospitalList: { hospitals, count: count - 1 } };
  }

  if (action.type === SET_CURRENT_HOSPITAL) {
    return { ...state, currentHospital: action.currentHospital };
  }

  if (action.type === GET_HOSPITALS_ALL) {
    return {
      ...state,
      hospitalList: action.hospitalList,
      offset: action.offset,
    };
  }

  if (action.type === CLEAR_ALL_HOSPITALS) {
    return { ...hospitalInitialState };
  }

  return state;
}

function chainManagementReducer(state = initialChainState, action) {
  if (action.type === CREATE_CHAIN_ADD) {
    return { ...state, chainList: action.chainList };
  }

  if (action.type === GET_CHAINS_ALL) {
    return { ...state, chainList: action.chainList, offset: action.offset };
  }

  if (action.type === GET_SEARCHED_CHAINS_ALL) {
    return { ...state, chainList: action.chainList };
  }

  return state;
}

function recordingReducer(state = initialRecordingState, action) {
  if (action.type === GET_RECORDING_LISTS) {
    return { ...state, recordings: action.recordings, offset: action.offset };
  }

  if (action.type === UPLOAD_RECORDING) {
    const updatedRecordings = state.recordings.recordings;
    updatedRecordings.unshift(action.payload);
    return {
      ...state,
      recordings: {
        count: state.recordings.count + 1,
        recordings: updatedRecordings,
      },
    };
  }

  if (action.type === DELETE_RECORDING) {
    const oldRecordings = state.recordings.recordings;
    oldRecordings.splice(
      oldRecordings.findIndex(
        (recording) => recording.id === action.record.file_id
      ),
      1
    );
    return {
      ...state,
      recordings: {
        count: state.recordings.count - 1,
        recordings: oldRecordings,
      },
    };
  }
  return state;
}

function ringGroupReducer(state = initialRingGroupState, action) {
  if (action.type === SET_RING_GROUP_LIST) {
    return {
      ...state,
      ringGroupList: action.ringGroupList,
      offset: action.offset,
    };
  }

  if (action.type === CREATED_RING_GROUP) {
    const updatedRingGroups = state.ringGroupList.ringGroups;

    updatedRingGroups.unshift(action.ringGroup);

    return {
      ...state,
      ringGroupList: {
        count: state.ringGroupList.count + 1,
        ringGroups: updatedRingGroups,
      },
    };
  }

  return state;
}

function ivrReducer(state = initialIVRCreateState, action) {
  if (action.type === SET_IVR_LIST) {
    return { ...state, ivrList: action.ivrList, offset: action.offset };
  }

  if (action.type === CREATED_IVR) {
    const updatedIVRS = state.ivrList.ivrs;

    updatedIVRS.unshift(action.ivr);

    return {
      ...state,
      ivrList: { count: state.ivrList.count + 1, ivrs: updatedIVRS },
    };
  }

  if (action.type === SET_WELCOME_MESSAGE_DATA) {
    return { ...state, welcomePageData: action.payload };
  }

  if (action.type === SET_KEY_ACTION_DATA) {
    return { ...state, chooseActionPageData: action.payload };
  }

  return state;
}

function nurseManagementReducer(state = initialNurseState, action) {
  if (action.type === CREATE_NURSE_ADD) {
    return { ...state, nurseList: action.nurseList };
  }

  if (action.type === GET_NURSES_ALL) {
    return { ...state, nurseList: action.nurseList, offset: action.offset };
  }

  if (action.type === GET_SEARCHED_NURSES_ALL) {
    return { ...state, nurseList: action.nurseList };
  }

  if (action.type === UPDATE_STATUS_NURSE_SUCCESS) {
    const { nurses } = state.nurseList;
    const id = nurses.findIndex((nurse) => nurse.id === action.nurse.id);
    nurses[id].status = action.nurse.status;

    return { ...state, nurseList: { ...state.nurseList, nurses } };
  }

  if (action.type === SET_NURSE_BY_ID) {
    return { ...state, nurse: action.nurse };
  }
  if (action.type === GET_NURSE_ROLES_WITH_PERM) {
    return { ...state, roles: action.roles };
  }

  return state;
}

function rolesReducer(state = initialRolesState, action) {
  if (action.type === SET_ROLES_LIST) {
    return { ...state, roleList: action.roleList };
  }

  return state;
}

function permissionReducer(state = initialPermissionState, action) {
  if (action.type === SET_ROLES_WITH_PERM_LIST) {
    return { ...state, rolePermList: action.rolePermList };
  }

  return state;
}

function helpAndSupportReducer(state = initialHelpAndSupportState, action) {
  if (action.type === GET_QUESTION) {
    return { ...state, questions: action.questions };
  }

  if (action.type === GET_CONTACT) {
    return { ...state, contacts: action.contacts };
  }

  if (action.type === GET_EMAIL) {
    return { ...state, emails: action.emails };
  }

  if (action.type === GET_MARKET_OUTREACH) {
    return { ...state, marketOutreach: action.marketOutreach };
  }

  return state;
}

function gvFeeReducer(state = { gvFee: [] }, action) {
  if (action.type === GET_GV_FEE) {
    return { ...state, gvFee: action.gvFee };
  }

  return state;
}

function dashboardReducer(state = dashboardState, action) {
  if (action.type === SET_DASHBOARD_ALL_DATA_COUNT) {
    return { ...state, allDataCount: action.payload };
  }

  if (action.type === SET_CUSTOMER_FEEDBACK) {
    if (action.payload.nurseFeedback && action.payload.dvmFeedback) {
      return {
        ...state,
        dvmFeedback: action.payload.dvmFeedback,
        nurseFeedback: action.payload.nurseFeedback,
      };
    }
    return state;
  }

  if (action.type === SET_CALLS_COUNT) {
    if (action.payload) {
      return {
        ...state,
        callsCountEveryHour: action.payload.call_per_hour,
        callsCountEveryDay: action.payload.call_per_day,
      };
    }
    return { ...state, callsCountEveryHour: null, callsCountEveryDay: null };
  }

  if (action.type === SET_PREFERENCES_ALL_VALUES) {
    return { ...state, allPreferenceValues: action.payload };
  }

  if (action.type === SET_TOP_ISSUES) {
    return { ...state, topFiveIssues: action.payload };
  }

  if (action.type === SET_CASES_COUNT_MONTH) {
    return { ...state, casesByMonth: action.payload };
  }

  if (action.type === SET_CASES_COUNT_WEEK) {
    return { ...state, casesByWeek: action.payload };
  }

  if (action.type === SET_CASES_COUNT_YEAR) {
    return { ...state, casesByYear: action.payload };
  }

  if (action.type === SET_CLIENTS_COUNT_MONTH) {
    return { ...state, clientsByMonth: action.payload };
  }

  if (action.type === GET_ALL_HOSPITAL_LIST) {
    return { ...state, allDashboardHospitalList: action.payload };
  }

  if (action.type === SET_PAYMENT_CALCULATION) {
    return { ...state, paymentCalculationValue: action.payload };
  }

  if (action.type === SET_TELE_MED_TOP_ISSUES) {
    return { ...state, teleMedTopFiveIssues: action.payload };
  }

  if (action.type === SET_AVG_CONSULATION_PRICE) {
    return { ...state, avgConsultationPrice: action.payload };
  }

  if (action.type === SET_DVM_USED_APP_COUNT) {
    return { ...state, dvmUsedAppCount: action.payload };
  }

  if (action.type === SET_USER_CREATED_PROFILECOUNT) {
    return { ...state, userCreateProfileCount: action.payload };
  }

  if (action.type === SET_APPOINTMENT_DVM_MONTH) {
    return { ...state, appointmentDVMMonth: action.payload };
  }

  if (action.type === SET_CURBSIDE_ANALYTICS) {
    return { ...state, curbsideAnalytics: action.payload };
  }

  if (action.type === RESET_DASHBOARD_DATA) {
    return {
      ...state,
      allDataCount: null,
      casesByWeek: [],
      casesByMonth: [],
      casesByYear: [],
      clientsByMonth: [],
      callsCountEveryHour: null,
      callsCountEveryDay: null,
      topFiveIssues: null,
      customerFeedback: null,
      dvmFeedback: null,
      nurseFeedback: null,
      teleMedTopFiveIssues: null,
      allPreferenceValues: null,
      avgConsultationPrice: 0,
      dvmUsedAppCount: 0,
      userCreateProfileCount: 0,
      appointmentDVMMonth: null,
      startDate: action.storeDate ? state.startDate : null,
      endDate: action.storeDate ? state.endDate : null,
      paymentCalculationValue: null,
      curbsideAnalytics: null,
    };
  }

  if (action.type === SET_START_END_DATE) {
    const { startDate, endDate } = action.payload;
    return { ...state, startDate, endDate };
  }

  return state;
}

/*
  reducer for clinic hours
*/
function clinicHoursReducer(state = clinicHoursState, action) {
  switch (action.type) {
    case SET_CLINIC_HOURS_EVENTS: {
      return { ...state, events: [...action.payload] };
    }
    case SET_CLINIC_HOURS_TIMEZONE: {
      return { ...state, timezone: action.payload };
    }
    case SET_SETUP_SCHEDULE_MODAL_VISIBILITY: {
      return { ...state, setUpScheduleState: action.payload };
    }
    case SET_INITIAL_DATE_CLINIC_HOURS: {
      return { ...state, initialDate: action.payload };
    }
    case SET_SETUP_SCHEDULE_EDIT_STATE: {
      return { ...state, setUpScheduleEdit: action.payload };
    }
    case SET_SETUP_SCHEDULE_DATE_CLICKED_STATE: {
      return { ...state, setUpScheduleDateClicked: action.payload };
    }
    case RESET_SETUP_SCHEDULE_DATA: {
      return {
        ...state,
        setUpScheduleData: {
          title: '',
          startDate: null,
          endDate: null,
          inTime: [null],
          outTime: [null],
          repeat: 'daily',
          repeatValue: '1',
          monthSelect: null,
          doctorId: 0,
          dayState: {
            0: false,
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false,
          },
        },
      };
    }
    case UPDATE_SETUP_SCHEDULE_DATA: {
      if (action.payload.key === 'dayState') {
        return {
          ...state,
          setUpScheduleData: {
            ...state.setUpScheduleData,
            [action.payload.key]: { ...action.payload.data },
          },
        };
      }
      return {
        ...state,
        setUpScheduleData: {
          ...state.setUpScheduleData,
          [action.payload.key]: action.payload.data,
        },
      };
    }
    case CLEAR_STATE_REDUX: {
      return clinicHoursState;
    }
    default:
      return { ...state };
  }
}

function paymentReducer(state = paymentInitialState, action) {
  switch (action.type) {
    case SET_PAYMENT_LISTING: {
      return {
        ...state,
        paymentList: [...action.paymentList],
        offset: action.offset,
        count: Number(action.count),
        cardValues: { ...action.cardValues },
      };
    }

    case SET_HOSPITAL_DVM_LISTING: {
      return { ...state, dvmList: [...action.dvmList] };
    }

    case SET_HOSPITAL_CONSULT_LISTING: {
      return { ...state, consultList: [...action.consultList] };
    }

    case SET_START_END_DATE_PAYMENT: {
      const { startDate, endDate } = action.payload;
      return { ...state, startDate, endDate };
    }

    case GET_ALL_HOSPITAL_LIST_PAYMENT: {
      return {
        ...state,
        allPaymentHospitalList: action.allPaymentHospitalList,
      };
    }

    case CLEAR_STATE_REDUX: {
      return paymentInitialState;
    }

    default:
      return { ...state };
  }
}

/* this greetings reducer
 */
function greetingsReducer(state = initialGreetingsState, action) {
  switch (action.type) {
    case GET_GREETINGS: {
      return { ...state, greetings: action.payload };
    }

    case CLEAR_GREETINGS: {
      return { ...state, greetings: [] };
    }

    default:
      return state;
  }
}

function commLogReducer(state = commLogInitialState, action) {
  switch (action.type) {
    case SET_START_END_DATE_COMM_LOG: {
      const { startDate, endDate } = action.payload;
      return { ...state, startDate, endDate };
    }

    case GET_CALL_MATRIX_SUCCESS: {
      const { matrics } = action.payload;
      return { ...state, callMatrics: matrics, showCallMatricsModal: true };
    }
    case 'CLOSE_MATRICS_MODAL': {
      return { ...state, showCallMatricsModal: false };
    }

    case GET_ALL_HOSPITAL_LIST_COMM: {
      return { ...state, allCommHospitalList: action.allCommHospitalList };
    }

    case SET_COMM_LOGS: {
      return {
        ...state,
        communicationLogs: [...action.communicationLogs],
        offset: action.offset,
        allLogsDetail: action.totalLogDetails,
        count: Number(action.count),
      };
    }

    case SET_CHAINED_HOSPITALS_COMM_LOG: {
      return { ...state, chainedHospitals: action.payload };
    }

    case CLEAR_STATE_REDUX: {
      return paymentInitialState;
    }

    default:
      return { ...state };
  }
}

function callNotificationsReducer(
  state = initialCallNotificationsState,
  action
) {
  if (action.type === SET_CALL_NOTIFICATIONS_LIST) {
    return { ...state, callNotifications: action.callNotifications };
  }

  if (action.type === SET_CALL_NOTIFICATIONS_MINUTES) {
    return { ...state, minutes: action.minutes };
  }

  return state;
}

/*
  reducer for the on call protocol
*/
function onCallProtocolReducer(state = onCallProtocolState, action) {
  switch (action.type) {
    case GET_REFERRAL_HOSPITAL_INFORMATION: {
      return { ...state, referralData: action.payload };
    }

    case POST_REFERRAL_HOSPITAL_INFORMATION: {
      const refferalDataArray = state.referralData;
      refferalDataArray.pop();
      refferalDataArray.push(action.payload.HospitalReferralInfo);
      return { ...state, referralData: [...refferalDataArray] };
    }
    case UPDATE_REFERRAL_HOSPITAL_INFORMATION: {
      const { data } = action.payload;
      const referralData = state.referralData.map((val) => {
        if (val.id === data.id) {
          return data;
        }
        return val;
      });
      return { ...state, referralData: [...referralData] };
    }

    case SET_ON_CALL_PROTOCOL: {
      return { ...state, onCallProtocol: action.payload };
    }

    case CLEAR_STATE_REDUX: {
      return onCallProtocolState;
    }

    default:
      return { ...state };
  }
}

function speciesMasterReducer(state = initialSpeciesMasterState, action) {
  if (action.type === SET_SPECIES_MASTER_LIST) {
    return { ...state, speciesList: action.speciesList, offset: action.offset };
  }

  return state;
}

function breedsMasterReducer(state = initialBreedsMasterState, action) {
  if (action.type === SET_BREEDS_MASTER_LIST) {
    return { ...state, breedsList: action.breedsList, offset: action.offset };
  }

  return state;
}

function gendersMasterReducer(state = initialGendersMasterState, action) {
  if (action.type === SET_GENDERS_MASTER_LIST) {
    return { ...state, gendersList: action.gendersList, offset: action.offset };
  }

  return state;
}

function statesMasterReducer(state = initialStatesMasterState, action) {
  if (action.type === SET_STATES_MASTER_LIST) {
    return { ...state, statesList: action.statesList, offset: action.offset };
  }

  return state;
}

function timezonesMasterReducer(state = initialTimezonesMasterState, action) {
  if (action.type === SET_TIMEZONES_MASTER_LIST) {
    return {
      ...state,
      timezonesList: action.timezonesList,
      offset: action.offset,
    };
  }

  return state;
}

function chiefComplaintsMasterReducer(
  state = initialChiefComplaintsMasterState,
  action
) {
  if (action.type === SET_CHIEF_COMPLAINTS_MASTER_LIST) {
    return {
      ...state,
      chiefComplaintsList: action.chiefComplaintsList,
      offset: action.offset,
    };
  }

  return state;
}

export default combineReducers({
  rootReducer,
  loginReducer,
  triageSetupReducer,
  hospitalDetailReducer,
  chainManagementReducer,
  recordingReducer,
  ringGroupReducer,
  ivrReducer,
  nurseManagementReducer,
  rolesReducer,
  permissionReducer,
  helpAndSupportReducer,
  gvFeeReducer,
  dashboardReducer,
  clinicHoursReducer,
  paymentReducer,
  greetingsReducer,
  commLogReducer,
  callNotificationsReducer,
  onCallProtocolReducer,
  speciesMasterReducer,
  breedsMasterReducer,
  gendersMasterReducer,
  statesMasterReducer,
  timezonesMasterReducer,
  chiefComplaintsMasterReducer,
  newDashboardReducer,
});
